import React from "react";
import cx from "classnames";
import _includes from "lodash/includes";
import _pickBy from "lodash/pickBy";
//
import Alert from "./Alert";

const premiumFeatures = [
  "Live chat to companions",
  "See photo verification",
  "Read user comments/reviews",
  "See age verification",
  "24h advanced and 1h bookings",
  "Offline searches & notifications",
];

export default function MarketingAlert({ className, features = [] }) {
  if (!features.length) {
    features = premiumFeatures;
  } else {
    features = _pickBy(premiumFeatures, (txt, idx) => _includes(features, idx));
  }

  return (
    <Alert className={cx(className, "alert--premium")}>
      <h4 className="u-mb-small">Not a Premium client yet?</h4>
      <p>Tons of benefits:</p>
      <ul className="u-mb-small u-pl">
        {features.map((txt) => (
          <li key={txt}>{txt}</li>
        ))}
      </ul>
      <p>
        <a className="u-link" href="/premium">
          Sign Up
        </a>
      </p>
    </Alert>
  );
}
